import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { RoutinePreview } from './components/routinePreview';
import { Routines } from './components/routines';
import { routinesPaths } from './routinesPaths';

export const routinesRoutes = [
  {
    path: `${routinesPaths.root}/:routineId/preview`,
    element: <RoutinePreview />,
    handle: {
      header: {
        titleKey: 'assets.list.routines',
        icon: 'format-list-checks',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${routinesPaths.root}/*`,
    element: <Routines />,
    handle: {
      header: {
        titleKey: 'assets.list.routines',
        icon: 'format-list-checks',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
];
